export const immutableObjectReducer = (state = {}) => state;
export const immutableArrayReducer = (state = []) => state;
export const immutableBoolReducer = (state = false) => state;
export const immutableStringReducer = (state = '') => state;
